import { useEffect, useMemo } from "react";

const JWT = /^[\w-]+\.[\w-]+\.[\w-]+$/;

const makeNonce = () => Array.from(crypto.getRandomValues(new Uint8Array(18)), (b) => b.toString(16).padStart(2, "0")).join("");

// Parent side of the bdg-app.js session bridge. Answers only (1) our own iframe's window, (2) for this app,
// (3) carrying the per-load nonce we put in the iframe URL fragment. A page the frame navigates to elsewhere
// never sees the fragment, so it can't get the token. Stores ONLY this app's token.
export const useAppBridge = (frameRef, appId) => {
  const nonce = useMemo(() => (appId ? makeNonce() : null), [appId]);
  useEffect(() => {
    if (!appId) return undefined;
    const keys = { token: `bdg_app_token:${appId}`, cart: `bdg_app_cart:${appId}` };
    const valid = { token: (v) => v.length < 2000 && JWT.test(v), cart: (v) => v.length < 4000 && /^\{[^<>]*\}$/.test(v) };
    const onMessage = (e) => {
      const frame = frameRef.current;
      const d = e.data;
      if (!frame || e.source !== frame.contentWindow || !d || d.bdgApp !== 1 || d.app !== appId || d.nonce !== nonce) return;
      const kind = d.key === "cart" ? "cart" : "token";
      const key = keys[kind];
      if (d.type === "set") {
        if (d.token && typeof d.token === "string" && valid[kind](d.token)) localStorage.setItem(key, d.token);
        else if (!d.token) localStorage.removeItem(key);
      } else if (d.type === "get") {
        frame.contentWindow.postMessage({ bdgApp: 1, type: "token", id: d.id, nonce, token: localStorage.getItem(key) }, "*");
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [frameRef, appId, nonce]);
  return nonce;
};

export const withNonce = (src, nonce) => (nonce ? `${src}#bdg=${nonce}` : src);
